module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett5-e78cd4a2377b5c815d5fc4236a177117.jpg";